import React from 'react';
import { formatPeriodLabel } from '../submissions/periodFormat';

export function ApprovedReportsList({ rows, page, pageCount, onPage, onDetail, onExportRow, onExportAll, exporting }) {
  if (!rows || rows.length === 0) {
    return <p className="submissions-empty">No approved reports match these filters.</p>;
  }
  return (
    <>
      <div className="list-toolbar">
        <button type="button" className="btn-secondary" onClick={onExportAll} disabled={exporting}>
          {exporting ? 'Exporting…' : 'Export all (CSV)'}
        </button>
      </div>
      <table className="submissions-table">
        <thead>
          <tr><th>Employee</th><th>Report</th><th>Period</th><th>Country</th><th>Approved by</th><th>Team Lead</th><th></th></tr>
        </thead>
        <tbody>
          {rows.map((r) => (
            <tr key={r.id}>
              <td>{r.submitter?.name || '—'}</td>
              <td>{r.report_systems?.name || '—'}</td>
              <td>{formatPeriodLabel(r.period, r.period_start, r.period_end)}</td>
              <td>{r.countryName || r.submitter?.countries?.name || '—'}</td>
              <td>{r.approvedByName || '—'}</td><td>{r.teamLeadName || '—'}</td>
              <td>
                <button type="button" className="btn-secondary" aria-label={`Download report from ${r.submitter?.name || 'employee'}`} title="Download CSV" onClick={() => onExportRow(r)}>⤓</button>
                <button type="button" className="btn-edit" onClick={() => onDetail(r)}>Details</button>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
      {pageCount > 1 && (
        <div className="pagination">
          <button type="button" className="btn-secondary" disabled={page === 0} onClick={() => onPage(page - 1)}>Prev</button>
          <span>Page {page + 1} of {pageCount}</span>
          <button type="button" className="btn-secondary" disabled={page + 1 >= pageCount} onClick={() => onPage(page + 1)}>Next</button>
        </div>
      )}
    </>
  );
}
